
import { namespace } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as sq from '~/store/modules/sq'
import * as cart from '~/store/modules/cart'

const Sq = namespace(sq.name)
const Cart = namespace(cart.name)

@Component({
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  },

  computed: {
    formattedExpectedActivationDate() {
      return new Date(this.expectedActivationDate).toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric'
        })
    }
  }
})
export default class ServiceQualificationResults extends Vue {
  @Prop({ default: null })
  readonly fromLandingPage: string | null

  @Sq.Getter
  sq
  
  @Sq.Getter
  isBusiness

  @Sq.Getter
  primaryNetwork

  @Sq.Getter
  hasFttpUpgrade: boolean

  @Sq.Getter
  hasFttpUpgradeComing: boolean

  @Sq.Mutation
  updatePrimaryNetwork

  @Sq.Getter
  networks

  @Sq.Getter
  addressChecked

  @Sq.Getter
  availableHeights

  @Sq.Action
  serviceQualification

  @Sq.Getter
  locationId

  @Sq.Getter
  ndc

  @Sq.Getter
  technology

  @Cart.Getter
  suggestedPromo

  @Cart.Getter
  salesPerson

  @Cart.Getter
  expectedActivationDate
}
